import React                     from 'react';
import merge                     from 'deepmerge';
import { Observe }               from 'rewire-core';
import { GridProps, IGridProps }             from 'rewire-grid';
import { WithStyle }             from 'rewire-ui';
import { Theme }                 from '@material-ui/core/styles';
import Grid                      from './Grid';
import { withStyles }            from '../utility/styles';

const styles = (theme: Theme) => ({
  grid: {
    '& tbody tr:hover': {
      backgroundColor: theme.palette.neutralLight.main,
    },
  }
});

interface IRowSelectionGridProps extends IGridProps {
  selectionColor?: string;
  className?: string;
}

type RowSelectionGridProps = WithStyle<ReturnType<typeof styles>, IRowSelectionGridProps & GridProps>;

class RowSelectionGrid extends React.PureComponent<RowSelectionGridProps> {
  render() {
    const {classes, grid, selectionColor, gridColors, gridFontSizes, ...props} = this.props;

    const selectionColorToUse           = selectionColor || this.props.theme?.palette.gridSelect.main;
    const defaultRowSelectionGridColors = {
      rowSelectedBackground:        selectionColorToUse,
      rowStripedSelectedBackground: selectionColorToUse,
      cellSelectedBackground:       selectionColorToUse,
      cellOutline:                  selectionColorToUse,
    };

    const gridColorsToUse = merge(defaultRowSelectionGridColors, gridColors || {});

    return <Observe render={() => {
      return <Grid grid={grid} className={classes.grid} gridColors={gridColorsToUse} gridFontSizes={gridFontSizes} {...props} />;
    }} />;
  }
}

export default withStyles<IRowSelectionGridProps>(styles, RowSelectionGrid);
